<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="ppp-differentpaths008htmlepigraph">
<p class="ct"><a class="xref" href="#/OEBPS/pppdifferentpaths006#ppp-differentpaths006htmltoc">Epigraph</a></p>
<p class="epf">We all of us have taken different paths now; but in</p>
<p class="epsl">This the first great fragmentation of my maturity, I feel the confines of my</p>
<p class="epsl">Art and my living deepening immeasurably by the memory of them.</p>
<p class="ept">—Lawrence Durrell, <i class="calibre5">Justine</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-differentpaths008.vue?25a9be04